import GroupPermission from './GroupPermission'
export default GroupPermission
